import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

function TopicSummary(props) {
  const { SummaryData, ContentColor } = { ...props }
  return (
    <div className="topic-topic-summary">
      <div className='summary_list'>
        {SummaryData && SummaryData.map(item => <div className='summary_item' key={item.id}>
          <div className='item_left'>
            <div className='item_content' style={{ color: ContentColor }}>
              <span className='content'>{item.content}</span>
              <span className='icon'>{item.icon}</span>
            </div>
            <div className='item_title'>{item.title}</div>
          </div>
          {item.right_icon && <div className='item_right'>{item.right_icon}</div>}
        </div>)}
      </div>
    </div>
  );
}
TopicSummary.propTypes = {
  topic: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopicSummary);



// WEBPACK FOOTER //
// ./src/features/topic/TopicSummary.js